import React, { useState, useEffect, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import style from './style'
import propTypes from './prop'
import MediaHeader from '../../components/media/header'
import { Grid, Box, Tab } from '@material-ui/core'
import ImageList from '@material-ui/core/ImageList'
import { mediaDirectoryGetRoot } from '../../reducers/media-directory/action'
import withStyles from '@material-ui/core/styles/withStyles'
import MediaItemFactory from '../../components/media/item/factory'
import translator from '../../translate'
import { mediaImageUploadAction } from '../../reducers/media-image/action'
import { componentBoxHideAction } from '../../reducers/component-box/action'
import {
  MediaDirectoryFieldNames,
  MediaItemType,
} from '../../model/media-directory'
import { mediaVideoUploadAction } from '../../reducers/media-video/action'

import URL from 'src/api/url'

import { TabContext, TabList, TabPanel } from '@material-ui/lab'
import { CoreButton, CoreIconButton, CoreTextField } from 'src/components/core'
import { Icon } from '@iconify/react'
import MediaItemVideo from 'src/components/media/item/video'

const VideoGallery = ({
  classes,
  popupType,
  onOk,
  //setImageURL,
}) => {
  const dispatch = useDispatch()
  const entity = useSelector(state => state.mediaDirectory.entity)

  // Split state into logical pieces
  const [items, setItems] = useState([])
  const [tabValue, setTabValue] = useState(1)
  const [folderId, setFolderId] = useState(null)

  const getMediaItemType = useCallback(fileType => {
    if (fileType === 'video/mp4') {
      return MediaItemType.VIDEO
    }

    return null
  }, [])

  // Effect for handling items changes
  useEffect(() => {
    if (items.length > 0) {
      onOk(items)
    }
  }, [items, onOk])

  const refreshList = useCallback(() => {
    dispatch(mediaDirectoryGetRoot(null, null, 'video'))
  }, [dispatch])

  const handleSelect = item => {
    //setImageURL(`${URL.STORAGE}${item.url}`)
    setItems([item])
  }

  const onDrop = useCallback(
    e => {
      if (tabValue !== 6) {
        const file = e.dataTransfer.files[0]
        const mediaType = getMediaItemType(file.type)
        if (!mediaType) return

        dispatch(mediaVideoUploadAction(file, folderId, refreshList))
        setTabValue(1)
        e.preventDefault()
        e.stopPropagation()
      }
    },
    [tabValue, getMediaItemType, dispatch, folderId, refreshList],
  )

  const onDragEnter = useCallback(
    e => {
      if (tabValue !== 6) {
        const fileType = e.dataTransfer.items[0].type
        const mediaType = getMediaItemType(fileType)

        if (!mediaType) {
          e.preventDefault()
          e.dataTransfer.effectAllowed = 'none'
          e.dataTransfer.dropEffect = 'none'
          setTabValue(0)
          return false
        }

        setTabValue(1)
        e.stopPropagation()
      }
    },
    [tabValue, getMediaItemType],
  )

  const onDragOver = useCallback(e => {
    e.preventDefault()
    e.stopPropagation()
  }, [])

  const onDragLeave = useCallback(
    e => {
      if (tabValue !== 6) {
        setTabValue(1)
        e.stopPropagation()
      }
    },
    [tabValue],
  )

  const renderItem = useCallback(
    mediaItem => {
      return MediaItemFactory(
        mediaItem,
        handleSelect,
        items.findIndex(i => i.id === mediaItem.id) !== -1,
      )
    },
    [handleSelect, items],
  )

  const closeHandler = useCallback(() => {
    dispatch(componentBoxHideAction())
  }, [dispatch])

  const choosePhoto = useCallback(
    (e, type) => {
      const file = e.target.files[0]
      const mediaType = getMediaItemType(file.type)

      if (!mediaType) return

      dispatch(mediaVideoUploadAction(file, folderId, refreshList))
      setTabValue(1)
      e.preventDefault()
      e.stopPropagation()
    },
    [dispatch, folderId, refreshList, getMediaItemType],
  )

  // Initial setup
  useEffect(() => {
    refreshList()
  }, [refreshList])

  const inputFileRef = React.useRef()

  return (
    <Grid
      container
      className={classes.root}
      onDragOver={onDragOver}
      onDragEnter={onDragEnter}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
    >
      {/*       <MediaHeader closeHandler={closeHandler} popupType={popupType} />
       */}{' '}
      <TabContext value={tabValue}>
        <React.Fragment>
          <Grid
            container
            className={classes.content}
            justifyContent="flex-start"
            alignContent="flex-start"
            alignItems="stretch"
          >
            <Grid item width={'100%'}>
              <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Grid item></Grid>
                <Grid item>
                  <CoreButton onClick={() => inputFileRef.current.click()}>
                    Upload
                  </CoreButton>
                  <input
                    type="file"
                    ref={inputFileRef}
                    accept="video/mp4"
                    onChange={event => choosePhoto(event)}
                    className={classes.imageUploadInput}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid
              className={
                entity && entity.results.length === 0 ? classes.imageGrid : null
              }
              item
              style={{
                maxHeight: '418px',
              }}
            >
              {entity && entity.results.length !== 0 ? (
                <ImageList className={classes.imageList} cols={4}>
                  {entity &&
                    entity.results.map(mediaItem => {
                      mediaItem.type = MediaItemType.VIDEO
                      mediaItem.dispatch = dispatch

                      let mediaProps = {
                        ...mediaItem,
                        key: mediaItem.id,
                        onSelect: handleSelect,
                        refreshList: refreshList,
                      }

                      return <MediaItemVideo {...mediaProps} />
                    })}
                </ImageList>
              ) : (
                <div className={classes.entityNull}>
                  <img
                    src="/assets/editor-file/media/empty-media.svg"
                    alt=""
                  ></img>
                </div>
              )}
            </Grid>
          </Grid>
        </React.Fragment>
      </TabContext>
    </Grid>
  )
}

VideoGallery.propTypes = propTypes

export default withStyles(style, { withTheme: true })(VideoGallery)
